<template lang="pug">
  a(href='#', :class="className", @click.prevent="scrollToContactForm")
    slot
</template>

<script>

export default {
  props: {
    subject: {
      type: String,
      required: true
    },
    className: {
      type: String,
      required: false,
      default: "btn btn-secondary uppercase leading-13 lg:px-12"
    }
  },
  methods: {
    scrollToContactForm () {
      this.$event.$emit('scroll-to-contact-form', { subject: this.subject })
    }
  }

}
</script>

<style>

</style>
